

































































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { cloneDeep, map } from 'lodash';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import ProductList from '@/components/product/product-list/ProductList.vue';
import ProductListContentImages from '@/components/product/product-list/ProductListContentImages.vue';
import ProductListContentTable from '@/components/product/product-list/ProductListContentTable.vue';
import { ProductUIInfo } from '@/store/modules/product';
import QrCode from 'qrcode.vue';
import copy from 'copy-to-clipboard';
import moment from 'moment';
import theme from '@/config/config-ui';

@Component({
    components: {
        ProductListContentImages,
        ProductListContentTable,
        QrCode,
    },
})
export default class ProductListContent extends Mixins(IsMobileMixin) {
    public copyToClibboardSnackBar = false;


    @Prop(Object) public product!: ProductUIInfo;

    get productInfo() {
        if (this.product) {
            return {
                Date: this.product.date ? moment(this.product.date).format('MMMM Do YYYY') : '',
                Time: this.product.date ? moment(this.product.time).format('hh:mm:ss') : '',
                Creator: this.product.owner,
                Address: this.product.address,
                'Serial Number': this.product.serialNumber,
                // 'Print Status': 'None',
                Details: this.details,
            };
        }
        return {};
    }

    get UUID() {
        return `https://vfy.luxtag.io/papyrus/${this.product.owner}/${this.product.serialNumber}/${this.product.address}`;
    }

    public productListContentEvent(action: string, label: any) {
        this.$ga.event('Product list content', 'click', action, label);
    }

    public emitClaimCode() {
        this.$emit('click:showProductClaimCode', this.product.privateKey);
    }

    public initCopy(text: any) {
        this.productListContentEvent('Copy PK or PB', 'copy icon');
        copy(text);
        this.copyToClibboardSnackBar = true;
    }

    get details() {
        const theDetails: any = cloneDeep(this.product.details);
        delete theDetails.img;
        const data = map(theDetails, x => x);
        return data.join(', ');
    }
}
